export const module = {
  info: {
    name: 'voip-destination',
    caption: 'voip destination'
  },
  vuexModules: ['api'],
  mainRoute: '/cpanel',
  // noRoutes: true,
}

export default module
